/* For page templates only */

(function () {
  'use strict';

  // Shared fetch options for the b2b (partner) endpoint.
  var header_options_b2bs = {
    method: 'GET',
    headers: {
      Accept: 'application/vnd.api+json',
    },
  };

  var $body = $('body');

  /* --------------------------------------------------------------------- *
   * Partner page (.body-crm-list)
   * --------------------------------------------------------------------- */
  if ($body.is('.body-crm-list')) {
    handlePartnerPage();
  }

  /* --------------------------------------------------------------------- *
   * Soziales Engagement page
   * --------------------------------------------------------------------- */
  if ($body.hasClass('page--soziales-engagement')) {
    handleSozialesEngagementPage();
  }

  /* ===================================================================== *
   * Partner page
   * ===================================================================== */
  function handlePartnerPage() {
    var isLieferpartner = $body.hasClass('body-crm-list-type--lieferpartner');

    if ($body.hasClass('body-crm-list-type--hauptpartner')) {
      renderHauptpartner();
    } else if ($body.hasClass('body-crm-list-type--fcsg-partner')) {
      get_partners(
        15,
        60,
        '.body-crm-list-type--fcsg-partner .fcsg-partner-sec .fcsg-partner-row',
        ''
      );
    } else if ($body.hasClass('body-crm-list-type--medical-and-health-partner')) {
      get_partners(
        17,
        60,
        '.body-crm-list-type--medical-and-health-partner .contentBuilder_v2_content #ipzvt.gjs-row .gjs-cell',
        'partner_contents_with_logo'
      );
    } else if ($body.hasClass('body-crm-list-type--medienpartner')) {
      get_partners(
        16,
        60,
        '.body-crm-list-type--medienpartner .contentBuilder_v2_content #ipzvt.gjs-row .gjs-cell',
        'partner_contents_with_logo'
      );
    } else if ($body.hasClass('body-crm-list-type--fcsg-supporter-plus')) {
      get_partners(
        41,
        60,
        '.body-crm-list-type--fcsg-supporter-plus .fcsg-partner-sec .fcsg-partner-row',
        ''
      );
    }

    if (isLieferpartner) {
      get_partners(
        20, // Lieferpartner
        13,
        '.body-crm-list-type--lieferpartner .contentBuilder_v2_content #ipzvt.gjs-row .gjs-cell',
        'partner_contents_with_logo'
      );
    }

    if ($body.hasClass('page--duale-ausbildung')) {
      get_partners(
        23,
        44,
        '.page--duale-ausbildung .contentBuilder_v2_content #imwqm.gjs-row .gjs-cell',
        'fcsg-partner-row'
      );
    }

    /**
     * Fetch partners for a customer group / tag and render them into a single
     * container (used by every partner page except Hauptpartner, which renders
     * multiple ordered sections via renderHauptpartner).
     *
     * @param {number} customerGroupId  crmSort customer group id
     * @param {number} crmTagId         crmSort tag id (optional)
     * @param {string} html_container   jQuery selector of the target container
     * @param {string} parent_class     class applied to the container
     */
    function get_partners(customerGroupId, crmTagId, html_container, parent_class) {
      parent_class = parent_class || '';

      var filter_crmSort = '';
      if (customerGroupId) {
        filter_crmSort = 'filter[crmSort][]=' + customerGroupId;
        if (crmTagId) {
          filter_crmSort =
            'filter[crmSort][]=' + customerGroupId + ',' + crmTagId;
        }
      }

      var requestUrl = API_URL + 'b2bs?' + filter_crmSort;

      fetch(requestUrl, header_options_b2bs)
        .then(function (response) {
          if (!response.ok) {
            throw new Error('HTTP ' + response.status);
          }
          return response.json();
        })
        .then(function (data) {
          var response_data = data && data.data;

          if (!response_data || response_data.length === 0) {
            $(html_container).find('.loader_wrap').remove();
            $(html_container).html('<p>Sie haben keine Partner.</p>');
            return;
          }

          var html = '';
          for (var c = 0; c < response_data.length; c++) {
            html += buildPartnerItemHtml(
              response_data[c].attributes,
              parent_class,
              isLieferpartner
            );
          }

          $(html_container).addClass(parent_class);
          $(html_container).html(html);

          if (isLieferpartner) {
            $(
              '.body-crm-list-type--lieferpartner .contentBuilder_v2_content .sponsor-grid'
            ).addClass('loaded');
          }

          $(html_container).find('.loader_wrap').remove();
          $(html_container).addClass('loaded');
        })
        .catch(function (error) {
          console.log('error', error);
          $(html_container).html(renderErrorHtml(error));
        });
    }

    /**
     * Hauptpartner page: several category sections, each backed by its own
     * request. Requests run in parallel, but sections are written into fixed,
     * index-ordered slots so the final DOM order always matches the category
     * list below — regardless of which response arrives first. An empty or
     * failed category only clears its own slot; it never wipes its siblings.
     */
    function renderHauptpartner() {
      var container = '.contentBuilder_v2_content #ipzvt.gjs-row .gjs-cell';
      var parent_class = 'partner_contents_with_logo';
      var categories = [
        { category: 'Hauptsponsor', crmTagId: 20 },
        { category: 'Naming Right', crmTagId: 21 },
        { category: 'Premium Sponsoren', crmTagId: 22 },
        { category: 'Platin Sponsoren', crmTagId: 23 },
        { category: 'Gold Sponsoren', crmTagId: 24 },
        { category: 'Silber Sponsoren', crmTagId: 25 },
      ];

      var $container = $(container);
      $container.addClass(parent_class);
      $container.find('.loader_wrap').remove();

      // Pre-create one ordered placeholder slot per category so DOM order is
      // fixed up front and each response only fills its own slot.
      var slots = categories.map(function (item, index) {
        var $slot = $(
          '<div class="partner_crm_wrap" data-crmID="' +
            item.crmTagId +
            '" style="order:' +
            index +
            ';"></div>'
        );
        $container.append($slot);
        return $slot;
      });

      var requests = categories.map(function (item, index) {
        var requestUrl =
          API_URL + 'b2bs?filter[crmSort][]=18,' + item.crmTagId;

        return fetch(requestUrl, header_options_b2bs)
          .then(function (response) {
            if (!response.ok) {
              throw new Error('HTTP ' + response.status);
            }
            return response.json();
          })
          .then(function (data) {
            var response_data = data && data.data;
            if (!response_data || response_data.length === 0) {
              // Nothing for this category: drop the empty slot.
              slots[index].remove();
              return;
            }

            var items = '';
            for (var c = 0; c < response_data.length; c++) {
              items += buildPartnerItemHtml(
                response_data[c].attributes,
                parent_class,
                isLieferpartner
              );
            }

            slots[index].html(
              '<h2 class="partner_heading h2">' +
                item.category +
                '</h2>' +
                '<div class="partner_contents ' +
                parent_class +
                '">' +
                items +
                '</div>'
            );
          })
          .catch(function (error) {
            console.log('error', error);
            slots[index].remove();
          });
      });

      // Mark the container loaded once every category has settled.
      Promise.all(requests).then(function () {
        $container.addClass('loaded');
      });
    }
  }

  /**
   * Build the markup for a single partner card.
   *
   * @param {Object}  attributes       b2b record attributes
   * @param {string}  parent_class     wrapper class (affects which fields show)
   * @param {boolean} isLieferpartner  whether we are on the Lieferpartner page
   * @returns {string}
   */
  function buildPartnerItemHtml(attributes, parent_class, isLieferpartner) {
    var company = attributes.company;
    var company_firstLetter = company ? company.charAt(0).toLowerCase() : 'a';
    if (!isNaN(company_firstLetter)) {
      company_firstLetter = 'a';
    }

    var website = attributes.website;
    var address_html = '';
    var beschreibung = '';

    if (attributes.crmAddresses && attributes.crmAddresses.length > 0) {
      var crmAddresses = attributes.crmAddresses[0].address;
      var address_email = crmAddresses.email;
      if (address_email) {
        address_email = address_email.replace('[at]', '@').replace('(at)', '@');
      }
      address_html +=
        (crmAddresses.addressLine1
          ? '<p class="addressLine1">' + crmAddresses.addressLine1 + '</p>'
          : '') +
        (crmAddresses.addressLine2
          ? '<p class="addressLine2">' + crmAddresses.addressLine2 + '</p>'
          : '') +
        (crmAddresses.zipCode || crmAddresses.city
          ? '<p class="zipCode">' +
            (crmAddresses.zipCode || '') +
            ' ' +
            (crmAddresses.city || '') +
            '</p>'
          : '') +
        (crmAddresses.phone
          ? '<p class="phone"><a href="tel:' +
            crmAddresses.phone +
            '">' +
            crmAddresses.phone +
            '</a></p>'
          : '') +
        (crmAddresses.email
          ? '<p class="email"><a href="mailto:' +
            address_email +
            '">' +
            crmAddresses.email +
            '</a></p>'
          : '');
    }

    if (attributes.customFields && attributes.customFields.length > 0) {
      for (var b = 0; b < attributes.customFields.length; b++) {
        var customFields = attributes.customFields[b];
        if (
          customFields.name === 'Beschreibung' &&
          customFields.locale === 'de_CH'
        ) {
          beschreibung = customFields.value;
        }
        if (
          parent_class === 'fcsg-partner-row' &&
          customFields.name === 'Mögliche Berufe:' &&
          customFields.value != null &&
          customFields.locale === 'de_CH'
        ) {
          beschreibung =
            '<strong>Mögliche Berufe: </strong>' + customFields.value;
        }
      }
    }

    var image = attributes.image;
    if (isLieferpartner) {
      var customerDocuments = attributes.customerDocuments;
      if (customerDocuments && customerDocuments.length > 0) {
        var document1 = customerDocuments.find(function (item) {
          return item.documentNumber === '1';
        });
        if (document1) {
          image = document1.document;
        }
      }
    }

    var showAddress = $body.hasClass('body-crm-list-type--fcsg-partner');

    if($('body').hasClass('template-name--club-partner')){
      beschreibung = '';
      showAddress = false;
    }

    return (
      '<div class="gjs-cell-item row-item" data-sort="' +
      company_firstLetter +
      '">' +
      '<div class="img-col">' +
      (image
        ? '<img alt="' + (company || '') + '" src="' + image + '">'
        : '<svg class="placeholder-svg placeholder" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5"></svg>') +
      '</div>' +
      '<div class="content-col">' +
      (company ? '<h2 class="title">' + company + '</h2>' : '') +
      (beschreibung ? '<p class="description">' + beschreibung + '</p>' : '') +
      (showAddress ? '<div class="address">' + address_html + '</div>' : '') +
      (website
        ? '<a href="' +
          website +
          '" target="_blank" class="link">Zur Webseite</a>'
        : '') +
      '</div>' +
      '</div>'
    );
  }

  /**
   * Generic error panel shown when a partner fetch fails.
   * @param {Error|string} error
   * @returns {string}
   */
  function renderErrorHtml(error) {
    return (
      '<div class="page-data">' +
      '<div class="error-container">' +
      '<h2 class="header">' +
      error +
      '</h2>' +
      '<div class="instructions">' +
      '<h2>Entschuldigung! Etwas lief schief bei uns. Wir versuchen derzeit, das Problem zu beheben.</h2>' +
      '<p>In der Zwischenzeit können Sie:</p>' +
      '<div class="step">' +
      '<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 489.711 489.711">' +
      '<path d="M112.156,97.111c72.3-65.4,180.5-66.4,253.8-6.7l-58.1,2.2c-7.5,0.3-13.3,6.5-13,14c0.3,7.3,6.3,13,13.5,13    c0.2,0,0.3,0,0.5,0l89.2-3.3c7.3-0.3,13-6.2,13-13.5v-1c0-0.2,0-0.3,0-0.5v-0.1l0,0l-3.3-88.2c-0.3-7.5-6.6-13.3-14-13    c-7.5,0.3-13.3,6.5-13,14l2.1,55.3c-36.3-29.7-81-46.9-128.8-49.3c-59.2-3-116.1,17.3-160,57.1c-60.4,54.7-86,137.9-66.8,217.1    c1.5,6.2,7,10.3,13.1,10.3c1.1,0,2.1-0.1,3.2-0.4c7.2-1.8,11.7-9.1,9.9-16.3C36.656,218.211,59.056,145.111,112.156,97.111z"></path>' +
      '<path d="M462.456,195.511c-1.8-7.2-9.1-11.7-16.3-9.9c-7.2,1.8-11.7,9.1-9.9,16.3c16.9,69.6-5.6,142.7-58.7,190.7    c-37.3,33.7-84.1,50.3-130.7,50.3c-44.5,0-88.9-15.1-124.7-44.9l58.8-5.3c7.4-0.7,12.9-7.2,12.2-14.7s-7.2-12.9-14.7-12.2l-88.9,8    c-7.4,0.7-12.9,7.2-12.2,14.7l8,88.9c0.6,7,6.5,12.3,13.4,12.3c0.4,0,0.8,0,1.2-0.1c7.4-0.7,12.9-7.2,12.2-14.7l-4.8-54.1    c36.3,29.4,80.8,46.5,128.3,48.9c3.8,0.2,7.6,0.3,11.3,0.3c55.1,0,107.5-20.2,148.7-57.4    C456.056,357.911,481.656,274.811,462.456,195.511z"></path>' +
      '</svg>' +
      '<p>Lade die Seite neu</p>' +
      '</div>' +
      '<div class="step">' +
      '<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">' +
      '<path d="M30,0C13.458,0,0,13.458,0,30s13.458,30,30,30s30-13.458,30-30S46.542,0,30,0z M30,58C14.561,58,2,45.439,2,30   S14.561,2,30,2s28,12.561,28,28S45.439,58,30,58z"></path>' +
      '<path d="M30,6c-0.552,0-1,0.447-1,1v23H14c-0.552,0-1,0.447-1,1s0.448,1,1,1h16c0.552,0,1-0.447,1-1V7C31,6.447,30.552,6,30,6z"></path>' +
      '</svg>' +
      '<p>Warte ein paar Minuten</p>' +
      '</div>' +
      '</div>' +
      '</div>' +
      '</div>'
    );
  }

  /* ===================================================================== *
   * Soziales Engagement page
   * ===================================================================== */
  function handleSozialesEngagementPage() {
    var news_soziales_url =
      API_URL +
      'news?sort=-publishDate&filter[isActive]=1&filter[isLightVersion]=true&filter[tag][]=Soziales Engagement';
    var news_soziales_settings = {
      method: 'GET',
      timeout: 0,
      headers: {
        Accept: 'application/vnd.api+json',
        'Cache-Control': 'max-age=600',
        'Content-Encoding': 'application/gzip',
      },
    };

    fetch(news_soziales_url, news_soziales_settings)
      .then(function (response) {
        if (!response.ok) {
          throw new Error('HTTP ' + response.status);
        }
        return response.json();
      })
      .then(function (response) {
        var data = response && response.data;
        if (data == null) {
          return;
        }

        var html = '<div id="news-container">';
        html +=
          '<div class="grid--4-col-desktop blog__posts articles-wrapper contains-card contains-card--article grid grid--peek grid--2-col-tablet">';
        html += generateNewsHtml(data);
        if (data.length === 0) {
          html +=
            '<p class="empty-category-text">Es liegen keine Neuigkeiten zum sozialen Engagement vor.</p>';
        }
        html += '</div></div>';

        $('#soziales-engagement-news').html(html);
      })
      .catch(function (error) {
        console.log('error', error);
      });
  }
})();
